export default __webpack_public_path__ + "static/media/a011-startup-06.d5ef669e.svg";